import React from "react";
import { Row, Col, Card, Collapse, Tabs, Button, Typography } from "antd";
import { ReactComponent as PlusIcon } from "../../../../assets/seller/icons/plus.svg";
import { ReactComponent as PlayLogo } from "../../../../assets/seller/icons/youtubeplay.svg";
import Video1Logo from "../../../../assets/seller/icons/HomeVideo1.webp";
import Video2Logo from "../../../../assets/seller/icons/HomeVideo2.webp";
import Video3Logo from "../../../../assets/seller/icons/HomeVideo3.webp";

const { TabPane } = Tabs;
const Text = Typography;

const HowItWorksSection = React.memo(({ activeKey, setActiveKey, handleModalOpen }) => (
  <>
    <section className="wow fadeInUp d-none d-md-none d-lg-block d-xl-block" style={{ padding: "40px 0" }}>
      <div className="container" style={{ margin: "0 auto" }}>
        <h2 className="txt-font-bigger">How does mobCREDIT work?</h2>
        <Row gutter={[16, 16]} justify="space-between" style={{ marginTop: "40px" }}>
          <Col>
            <Tabs defaultActiveKey="1" className="homepage-video-tab" tabPosition={"left"}>
              <TabPane
                key="1"
                tab={
                  <Collapse className="custom-collapse width-100" activeKey={activeKey} onChange={(key) => setActiveKey(key)} defaultActiveKey={["1"]} accordion expandIconPosition="end" expandIcon={({ isActive }) => (isActive ? "" : <PlusIcon />)}>
                    <Collapse.Panel header={<div className="text-left"><span>1. Easy registration with GSTIN</span></div>} key="1">
                      <span className="f-small-text overflow-text">Easy registration with GSTIN - mobPartner (36 secs) - Sales management + Line of Credit</span>
                    </Collapse.Panel>
                  </Collapse>
                }
              >
                <Card className="video-card-content card-easyline  mb-2" onClick={() => handleModalOpen("SpFemJFcfa4", "Easy registration with GSTIN (36 secs)")}>
                  <img width={"100%"} src={Video2Logo} alt="Easy registration with GSTIN (36 secs)"></img>
                  <div className="d-flex justify-content-center cls-center-img"><Button className="play-button" type="text"><PlayLogo /></Button></div>
                </Card>
              </TabPane>
              <TabPane
                key="2"
                tab={
                  <Collapse className="custom-collapse width-100" activeKey={activeKey} onChange={(key) => setActiveKey(key)} accordion expandIconPosition="end" expandIcon={({ isActive }) => (isActive ? "" : <PlusIcon />)}>
                    <Collapse.Panel header={<div className="text-left"><span>2. Activate Line of Credit</span></div>} key="2">
                      <span className="f-small-text overflow-text">Activate Line of Credit - mobPartner (88 secs) - Sales management + Line of Credit</span>
                    </Collapse.Panel>
                  </Collapse>
                }
              >
                <Card className="video-card-content card-easyline mb-2" onClick={() => handleModalOpen("3AakpS6zLZY", "Activate Line of Credit (88 secs)")}>
                  <img width={"100%"} src={Video3Logo} alt="Activate Line of Credit (88 secs)"></img>
                  <div className="d-flex justify-content-center cls-center-img"><Button className="play-button" type="text"><PlayLogo /></Button></div>
                </Card>
              </TabPane>
              <TabPane
                key="3"
                tab={
                  <Collapse className="custom-collapse width-100" activeKey={activeKey} onChange={(key) => setActiveKey(key)} accordion expandIconPosition="end" expandIcon={({ isActive }) => (isActive ? "" : <PlusIcon />)}>
                    <Collapse.Panel header={<div className="text-left"><span>3. Create mobCREDIT/ store sales</span></div>} key="3">
                      <span className="f-small-text overflow-text">Manage store sales - mobPartner (36 secs) - Sales management + Line of Credit</span>
                    </Collapse.Panel>
                  </Collapse>
                }
              >
                <Card className="video-card-content card-easyline mb-2" onClick={() => handleModalOpen("NFy5mCrdZgY", "Manage store sales (36 secs)")}>
                  <img width={"100%"} src={Video1Logo} alt="Manage store sales (36 secs)"></img>
                  <div className="d-flex justify-content-center cls-center-img"><Button type="text" className="play-button"><PlayLogo /></Button></div>
                </Card>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </div>
    </section>
    <section className="wow fadeInUp d-block d-sm-block d-lg-none d-xl-none" style={{ padding: "20px 0" }}>
      <div className="container" style={{ margin: "0 auto" }}>
        <h2 className="txt-font-bigger">How does mobCREDIT work?</h2>
        <Row gutter={[16, 16]} justify="space-between" style={{ marginTop: "20px" }}>
          <Col span={24}>
            <Collapse className="home-collapse" expandIconPosition="right" expandIcon={({ isActive }) => (isActive ? "" : <PlusIcon />)} defaultActiveKey={["1"]} accordion={true}>
              <Collapse.Panel header={<div className="text-left"><span className="txt-collapse-heading">1. Easy registration with GSTIN</span></div>} key="1">
                <p>
                  <Card className="video-card-content card-easyline p-0  mb-2" onClick={() => handleModalOpen("SpFemJFcfa4", "Easy registration with GSTIN (36 secs)")}>
                    <Text className="mb-2">Easy registration with GSTIN - mobPartner (36 secs) - Sales management + Line of Credit</Text>
                    <img width={"100%"} src={Video2Logo} alt="Easy registration with GSTIN (36 secs)"></img>
                    <div className="d-flex justify-content-center cls-center-img-mob  "><Button className="play-button" type="text"><PlayLogo /></Button></div>
                  </Card>
                </p>
              </Collapse.Panel>
              <Collapse.Panel header={<div className="text-left"><span className="txt-collapse-heading">2. Activate Line of Credit</span></div>} key="2">
                <p>
                  <Card className="video-card-content p-0 card-easyline mb-2" onClick={() => handleModalOpen("3AakpS6zLZY", "Activate Line of Credit (88 secs)")}>
                    <Text className="mb-2">Activate Line of Credit - mobPartner (88 secs) - Sales management + Line of Credit</Text>
                    <img width={"100%"} src={Video3Logo} alt="Activate Line of Credit (88 secs)"></img>
                    <div className="d-flex justify-content-center cls-center-img-mob"><Button className="play-button" type="text"><PlayLogo /></Button></div>
                  </Card>
                </p>
              </Collapse.Panel>
              <Collapse.Panel header={<div className="text-left"><span className="txt-collapse-heading">3. Manage store sales</span></div>} key="3">
                <p>
                  <Card className="video-card-content p-0 card-easyline mb-2" onClick={() => handleModalOpen("NFy5mCrdZgY", "Manage store sales (36 secs)")}>
                    <Text className="mb-2">Manage store sales - mobPartner (36 secs) - Sales management + Line of Credit</Text>
                    <img width={"100%"} src={Video1Logo} alt="Manage store sales (36 secs)"></img>
                    <div className="d-flex justify-content-center cls-center-img-mob"><Button type="text" className="play-button"><PlayLogo /></Button></div>
                  </Card>
                </p>
              </Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
      </div>
    </section>
  </>
));

export default HowItWorksSection;
